<template>
    <CModal
        :title="titleComponent"
        :show="showComponent"
        :color="colorComponent"
        :size="sizeComponent"
    >
        <CForm ref="formChangePassword" @submit="formSubmit($event, 'changePassword')">
            <PasswordInputComponent
                :isValid="
                    checkIfFormValid({
                        formName: 'changePassword',
                        fieldName: 'oldPassword',
                    })
                "
                :value.sync="$v.forms.changePassword.oldPassword.$model"
                :label="$t('old_password')"
            />
            <PasswordInputComponent
                :isValid="checkIfFormValid({
                    formName:'changePassword',
                    fieldName:'newPassword'
                })" 
                :value.sync="$v.forms.changePassword.newPassword.$model"
                :label="$t('new_password')"
            />

            <PasswordInputComponent
                :isValid="checkIfFormValid({
                    formName:'changePassword',
                    fieldName:'newPasswordConfirmation'
                })" 
                :value.sync="$v.forms.changePassword.newPasswordConfirmation.$model"
                :label="$t('new_password_confirmation')"
            />

            <ButtonLoading type="submit" :block="true" color="primary" :loading="forms.changePassword._loading">
                <span>{{ $t("change_password")}}</span>
            </ButtonLoading>
        </CForm>
        <template #footer>
            <CButton color="secondary" @click="closeModal()">
                {{ $t("cancel") }}
            </CButton>
            <ButtonLoading color="success" @click="executeSubmitForm" :loading="forms.changePassword._loading">
                {{ $t("change_password") }}
            </ButtonLoading>
        </template>
    </CModal>
</template>

<script>
import formMixin from "~/mixins/form";
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators";

import PasswordInputComponent from "~/components/PasswordInput.vue";
import ButtonLoading from "~/components/ButtonLoading.vue";

export default {
    name: "ChangeUserPasswordModal",
    mixins: [formMixin, validationMixin],
    components:{
        PasswordInputComponent,
        ButtonLoading
    },
    props: {
        title: String,
        show: Boolean,
        color: String,
        size: String,
        data: Object,
    },

    data() {
        return {
            titleComponent: null,
            showComponent: false,
            colorComponent: "primary",
            sizeComponent: "lg",
            dataComponent: {},

            forms: {
                changePassword: {
                    oldPassword: null,
                    newPassword: null,
                    newPasswordConfirmation: null,
                    _loading: false,
                },
            },
        };
    },

    validations: {
        forms: {
            changePassword: {
                oldPassword: {
                    required,
                },
                newPassword: {
                    required,
                },
                newPasswordConfirmation: {
                    required,
                    sameAsPassword: sameAs('newPassword')
                },
                
            },
        },
    },

    watch: {
        title() {
            this.titleComponent = this.title;
        },
        show() {
            this.showComponent = this.show;
            if(!this.show){
                this.resetForm('changePassword');
                this.$v.$reset();
            }
        },
        color() {
            this.colorComponent = this.color;
        },
        size() {
            this.sizeComponent = this.size;
        },
        showComponent() {
            this.$emit("update:show", this.showComponent);
        },
        data(){
            this.dataComponent = this.data;
        }
    },

    methods: {
        closeModal() {
            this.showComponent = false;
        },

        async formSubmit(e, formName) {
            e.preventDefault();
            let response = await this.sendForm({
                formName,
                url: "/account.api/user/change/password",
                method: "PUT",
            });
            this.showComponent = false;

            this.$emit("submit", response);
        },

        executeSubmitForm() {
            this.$refs.formChangePassword.requestSubmit();
        },
    },

    mounted() {
        this.titleComponent = this.title;
        this.showComponent = this.show;
        this.colorComponent = this.color;
        this.sizeComponent = this.size;
        this.dataComponent = this.data;
        
    },
};
</script>

<style>
</style>